export class PinHelper {
    static validatePin(pin, contentId) {
        let validatePinAJAX = $.Deferred();
        validatePinAJAX.promise();

        $.getJSON('/video/validatepin/', { contentId: contentId, pin: btoa(pin) }, function (data) {
            if (data && data.success && data.result) {
                validatePinAJAX.resolve(data.result.valid);
            } else {
                validatePinAJAX.reject();
            }
        });
        return validatePinAJAX;
    }
}
